var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clearfix" }, [
    _c(
      "div",
      {
        ref: "nextReviewerModal",
        staticClass: "reveal next-reviewer-modal",
        attrs: { id: "nextReviewerModal", "data-reveal": "" },
      },
      [
        _c("div", { staticClass: "tender-confirm clearfix" }, [
          _c(
            "div",
            {
              class: {
                "required-error-highlight":
                  _vm.inputRequireHighlight && !_vm.newReviewer,
              },
            },
            [
              _c("label", { staticClass: "next-reviewer-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("tenantProjects.submission.selectNextReviewer"))
                ),
              ]),
              _vm._v(" "),
              _c("HKLSelect", {
                staticClass: "next-reviewer-selector",
                attrs: {
                  value: _vm.newReviewerId || undefined,
                  options: _vm.reviewerHklOptions,
                  showSearch: true,
                  placeholder: "",
                },
                on: { change: _vm.onReviewerChange },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.techCommentActionTexts.length > 0
            ? _c("div", { staticClass: "tech-reviewers-list" }, [
                _c("div", { staticClass: "reviewers-list-title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("tenantProjects.submission.prevReviewerList")
                      ) +
                      ":\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ol",
                  _vm._l(_vm.techCommentActionTexts, function (item) {
                    return _c(
                      "li",
                      { key: item, staticClass: "reviewers-list-item" },
                      [_vm._v("\n            " + _vm._s(item) + "\n          ")]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row align-right nav_btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              attrs: { id: "confirm_no", type: "button", "data-close": "" },
            },
            [_vm._v(_vm._s(_vm.$t("action.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { id: "confirm_ok", type: "button" },
              on: {
                click: function ($event) {
                  return _vm.changeAssignee()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.submit")))]
          ),
        ]),
        _vm._v(" "),
        _vm.invalidTechManager
          ? _c("div", { staticClass: "error-msg", attrs: { lang: "en" } }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("tenantProjects.submission.submittefFailedErrMsg")
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }